export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/AlfaPoints.99955b0f.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};